import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms6ke/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms6ke/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      if (isMock) return generator(mocker.index())
      sendParams = {
        p_dtereq_st: (typeof searchParams.dtereqst.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqst.replace(/\//g, '') : ''),
        p_dtereq_en: (typeof searchParams.dtereqen.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqen.replace(/\//g, '') : ''),
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
        p_codempid_query: (typeof searchParams.codempid !== 'undefined' && searchParams.codempid !== '' ? searchParams.codempid : '')
      }
      return instance().get(endpoint + '/hrms6ke/index', { params: sendParams })
    } else {
      return generator({
        total: 0,
        rows: []
      })
    }
  },
  getCreate (searchDetail) {
    return generator(mocker.create())
  },
  getDetail (searchDetail) {
    let sendParams = {
      p_numotgen: searchDetail.numotgen
    }
    if (isMock) return generator(mocker.detail())
    const params = sendParams.p_numotgen
    return instance().get(endpoint + '/hrms6ke/detail/' + params)
  },
  postDetailTab2Process (processParams) {
    if (isMock) return generator(mocker.detailTab2Process())
    let params = {
      p_dtereq: processParams.dtereq,
      p_staappr: processParams.staappr,
      p_routeno: processParams.routeno,
      p_dtestrt: processParams.dtestrt,
      p_dteend: processParams.dteend,
      p_timbstr: processParams.timbstr,
      p_timbend: processParams.timbend,
      p_timdstr: processParams.timdstr,
      p_timdend: processParams.timdend,
      p_timastr: processParams.timastr,
      p_timaend: processParams.timaend,
      p_codrem: processParams.codrem,
      p_remark: processParams.remark,
      p_codcomp: processParams.codcomp,
      p_codcalen: processParams.codcalen,
      p_codshift: processParams.codshift,
      p_codempid: processParams.codempidQuery
    }
    return instance().post(endpoint + '/hrms6ke/detailTab2', params)
  },
  getDetailTab2AddInline (param) {
    if (isMock) return generator(mocker.detailTab2AddInline(param))
    const params = param.codempid + '/' + param.dtework.replace(/\//g, '')
    return instance().get(endpoint + '/hrms6ke/detailTab2AddInline/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hrms6ke/dropdowns')
  },
  postSave (detail) {
    let sendParams = {
      numotgen: detail.numotgen,
      codempid: detail.tab1.codempid,
      dtereq: detail.tab1.dtereq,
      staappr: detail.tab1.staappr,
      routeno: detail.tab1.routeno,
      dtestrt: detail.tab1.dtestrt,
      dteend: detail.tab1.dteend,
      timbstr: detail.tab1.timbstr,
      timbend: detail.tab1.timbend,
      timdstr: detail.tab1.timdstr,
      timdend: detail.tab1.timdend,
      timastr: detail.tab1.timastr,
      timaend: detail.tab1.timaend,
      codrem: detail.tab1.codrem,
      remark: detail.tab1.remark,
      codcomp: detail.tab1.codcomp,
      codcalen: detail.tab1.codcalen,
      codshift: detail.tab1.codshift,
      param_tab2: JSON.stringify(detail.tab2)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms6ke/save', sendParams)
  },
  postDelete (saveParams) {
    let sendParams = {
      param_index: JSON.stringify(saveParams)
    }
    if (isMock) return generator(mocker.delete())
    return instance().post(endpoint + '/hrms6ke/delete', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms6ke/index.js